(() => {
  const script = document.currentScript;
  const labels = {
    print: script?.dataset.printLabel || 'Print policy',
    toc: script?.dataset.tocLabel || 'On this page',
    tocAria: script?.dataset.tocAria || 'Policy sections',
    table: script?.dataset.tableLabel || 'Scrollable policy table',
  };

  const enhancePolicy = () => {
    const container = document.querySelector('.shopify-policy__container');
    const body = container?.querySelector('.shopify-policy__body');

    if (!container || !body || container.dataset.starPolicyEnhanced === 'true') return;
    container.dataset.starPolicyEnhanced = 'true';

    const headings = [...body.querySelectorAll('h2, h3')];
    const usedIds = new Set([...document.querySelectorAll('[id]')].map((element) => element.id));

    for (const [index, heading] of headings.entries()) {
      if (heading.id) continue;

      const base = heading.textContent
        .trim()
        .toLowerCase()
        .normalize('NFKD')
        .replace(/[\u0300-\u036f]/g, '')
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/^-|-$/g, '') || `section-${index + 1}`;
      let candidate = `policy-${base}`;
      let suffix = 2;

      while (usedIds.has(candidate)) {
        candidate = `policy-${base}-${suffix}`;
        suffix += 1;
      }

      heading.id = candidate;
      usedIds.add(candidate);
    }

    const tools = document.createElement('div');
    tools.className = 'star-policy-tools';

    const actions = document.createElement('div');
    actions.className = 'star-policy-tools__actions';

    const printButton = document.createElement('button');
    printButton.className = 'star-policy-tools__print';
    printButton.type = 'button';
    printButton.textContent = labels.print;
    printButton.addEventListener('click', () => window.print());
    actions.append(printButton);
    tools.append(actions);

    if (headings.length > 1) {
      const navigation = document.createElement('nav');
      navigation.className = 'star-policy-tools__toc';
      navigation.setAttribute('aria-label', labels.tocAria);

      const label = document.createElement('strong');
      label.textContent = labels.toc;
      navigation.append(label);

      const list = document.createElement('ul');
      for (const heading of headings.filter((item) => item.tagName === 'H2')) {
        const item = document.createElement('li');
        const link = document.createElement('a');
        link.href = `#${heading.id}`;
        link.textContent = heading.textContent.trim();
        item.append(link);
        list.append(item);
      }
      navigation.append(list);
      tools.append(navigation);
    }

    container.insertBefore(tools, body);

    for (const [index, table] of [...body.querySelectorAll('table')].entries()) {
      if (table.parentElement?.classList.contains('star-policy-table-wrap')) continue;

      const wrapper = document.createElement('div');
      wrapper.className = 'star-policy-table-wrap';
      wrapper.setAttribute('role', 'region');
      wrapper.setAttribute('aria-label', `${labels.table} ${index + 1}`);
      wrapper.tabIndex = 0;
      table.before(wrapper);
      wrapper.append(table);
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', enhancePolicy, { once: true });
  } else {
    enhancePolicy();
  }
})();
